import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from "react";
import { bool } from "prop-types";
import { ProgressBar } from "@icg360/ui-toolkit";

var FormProgressBar = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FormProgressBar, _Component);

  function FormProgressBar(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.timer = function () {
      var loadingProgress = _this.state.loadingProgress; // Calculate new percent
      // Latest data shows a transaction should take:
      //   - ~8 seconds for a preview
      //   - ~18 seconds for the actual commit
      // We'll plan on having the progress bar hit ~70% after 20 seconds.
      // (an increase of one percent, 4 times per second)
      // Under promise, over deliver.

      var newLoadingProgress = loadingProgress;

      if (loadingProgress < 70) {
        newLoadingProgress += 1; // 17.5 seconds elapsed
      } else if (loadingProgress < 80) {
        newLoadingProgress += 0.5; // 22.5 seconds elapsed
      } else if (loadingProgress < 90) {
        newLoadingProgress += 0.25; // 32.5 seconds elapsed
      } else if (loadingProgress < 98) {
        newLoadingProgress += 0.1; // 57 seconds elapsed
      }

      _this.setState({
        loadingProgress: newLoadingProgress
      });
    };

    _this.state = {
      intervalId: null,
      // gets set in componentDidMount()
      loadingProgress: 1
    };
    return _this;
  }

  var _proto = FormProgressBar.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var intervalId = setInterval(this.timer.bind(this), 250);
    this.setState({
      intervalId: intervalId
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    // Clean the interval in case it doesn't get cleaned up in
    // `animateProgressBarToComplete()`, like if a user cancels a request
    // before it's done.
    var intervalId = this.state.intervalId;
    clearInterval(intervalId);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        animateProgressBarToComplete = _this$props.animateProgressBarToComplete,
        isEdit = _this$props.isEdit;
    var loadingProgress = this.state.loadingProgress;
    return /*#__PURE__*/React.createElement("div", {
      className: "text-muted text-center",
      style: {
        width: "90%",
        margin: "0 auto 20px",
        padding: "70px 0 40px"
      }
    }, /*#__PURE__*/React.createElement(ProgressBar, {
      active: true,
      now: animateProgressBarToComplete ? 100 : loadingProgress,
      style: {
        marginBottom: "6px"
      }
    }), isEdit ? "Processing preview..." : "Processing changes...");
  };

  return FormProgressBar;
}(Component);

FormProgressBar.propTypes = {
  animateProgressBarToComplete: bool.isRequired,
  isEdit: bool.isRequired
};
export { FormProgressBar as default };